import type { Price } from 'types/capi/shared';

import KlarnaIcon from '~/assets/icons/KlarnaBadge';

type Props = {
  price?: Price | null;
};

const KlarnaPlacement = ({ price }: Props) => {
  return (
    <div className="flex items-center gap-4 rounded-lg border border-solid border-concrete px-4 py-2">
      <KlarnaIcon height="24" width="43" />
      {price?.regular ? (
        <div className="flex flex-col gap-1">
          <span className="text-sm text-black">
            Pay later in 30 days with Klarna.
          </span>
          <span className="text-sm text-grey-read">
            18+, T&C apply, subject to status.
          </span>
        </div>
      ) : (
        <span className="text-sm font-normal">
          <div>Pay later in 30 days with Klarna.</div>
          <a
            href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_gb/user"
            target="_blank"
            className="text-xs font-semibold underline"
            rel="noreferrer"
          >
            Learn more.
          </a>
        </span>
      )}
    </div>
  );
};
export default KlarnaPlacement;
